var GuestStep = (function () {

    var $joinGuestEmail = $("#joinGuestEmail");
    var $guestStep = $("#guestStep");

    var ERROR_CODE = {
        NO_PROBLEM: '0000',
        EXISTS_EMAIL: '5000',
    }

    return {
        openGuestStep: openGuestStep,
    }

    function openGuestStep() {
        $("#userStep").fadeOut(0);
        $("#basicStep").fadeOut(0);
        //스크롤 내려가는 이슈 있어서 top으로 고정
        $(document).scrollTop(0);
        $guestStep.fadeIn(200);

        $guestStep.find("input").off("keyup").on("keyup", CommonJoin.keyupJoinInput);
        if (Often.isMobile() || Often.isTablet()) {
            $guestStep.find(".js-view-button").on("mousedown", CommonJoin.mousedownViewToggleButton);
        } else {
            $guestStep.find(".js-view-button").on({
                mouseup: CommonJoin.mouseupViewButton,
                mousedown: CommonJoin.mousedownViewButton,
            });
        }
        $joinGuestEmail.on("focusout", CommonJoin.focusoutJoinInput);
        $("#guestConfirmCheck").off("click").on("click", CommonJoin.clickConfirmCheck);
        $("#ageLimitGuestConfirmCheck").off("click").on("click", CommonJoin.clickConfirmCheck);
        $guestStep.find(".js-confirm-check").off("keydown").on("keydown", CommonJoin.useSpaceBarToCheck);

        const _checksExternalLogin = CommonLogin.checksExternalLogin;

        addSubmitEvent($("#googleLoginButton"), () => {
            _checksExternalLogin(GoogleLogin.clickGoogleLoginButton);
        }, googleApiAvailable);
        addSubmitEvent($("#kakaoLoginButton"), () => {
            _checksExternalLogin(KakaoLogin.clickKakaoLoginButton);
        }, kakaoApiAvailable);
        addSubmitEvent($("#appleLoginButton"), () => {
            _checksExternalLogin(AppleLogin.clickAppleLoginButton);
        }), appleApiAvailable;

        addSubmitEvent($("#userStepButton"), (e) => CommonJoin.changeFirstStepButton(e));
        addSubmitEvent($("#guestFinalButton"), (e) => CommonJoin.moveSecondStepButton(e, openGuestFinalStep));

        if(!Often.isGlobal())GoogleTagManager.collect({event: 'guestup1'});
    }

    function addSubmitEvent($button, event, isActive = true) {
        $button
            .off("click").on("click", isActive && event)
            .off("keyup").on("keyup", (e) => {
            if (isActive && KeyCheck.isKey(e, "ENTER")) {
                event(e);
            }
        });
    }

    function openGuestFinalStep() {
        const userInfo = CommonJoin.getUserInfo("joinGuest");
        userInfo.packetOption = Ajax.OPTION.PREVENT_EXECUTE;
        const partnerInfo = CommonJoin.getPartnerInfo();
        const reqData = {...userInfo, ...partnerInfo};
        Ajax.executeApi(RestApi.POST.COLABO2_REGISTER_C001, reqData, function (dat) {
            var errorCode = Often.null2Void(dat['ERR_CD'], '');
            if (ERROR_CODE.NO_PROBLEM !== errorCode) {
                if (ERROR_CODE.EXISTS_EMAIL === errorCode) {
                    CommonJoin.changeInputErrorMsg($joinGuestEmail, $joinGuestEmail.attr("data-un-valid-msg2"));
                }
            }
            $guestStep.fadeOut(0);
            $("#guestFinalStep").fadeIn(200);

            GoogleTagManager.collect({
                event: "guest",
                userId: userInfo.USER_ID,
                guestDate: Time.currentTime(),
            })

            if(!Often.isGlobal())GoogleTagManager.collect({event: 'guestup2'});

            $("#guestStartButton").off("click").on("click", function () {
                Loading.drawLoadingPop(true);
                CommonJoin.goLoginAfterJoin(userInfo);
            });

        })
    }
})();